import { useState } from 'react';
import { useDispatch } from "react-redux";
import { notificationActions } from "../actions";
import { useDeepCompareEffect } from "react-use";

const useAsyncSearch = (options) => {
    const { params, term, request, defaultValue = null }
        = options;

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(defaultValue);
    const dispatch = useDispatch();

    useDeepCompareEffect(() => {
        if (!params || !request || !term)
            return;

        let subscribed = true;
        setLoading(true);

        request(...params, term)
            .then(res => {
                setData(res.data);
            })
            .catch(err => {
                if (!err.intercepted)
                    dispatch(notificationActions.showError({ message: err.message }));
            })
            .finally(() => {
                if (subscribed)
                    setLoading(false)
            });

        return () => subscribed = false
    }, [JSON.stringify(params), term, request, defaultValue, dispatch]);

    return [loading, data];
}

export default useAsyncSearch;